import { render, staticRenderFns } from "./ShareBlack.vue?vue&type=template&id=0da6b754&scoped=true&"
var script = {}
import style0 from "./ShareBlack.vue?vue&type=style&index=0&id=0da6b754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da6b754",
  null
  
)

export default component.exports